import { checkIsActive } from "@/services/system/feature_flags";

export default {
  namespaced: true,
  state: {
    features: [],
  },
  getters: {
    getFeature: (state) => (slug) => {
      return state.features.find((feature) => feature.slug === slug);
    },
    isFeatureActive: (state) => (slug) => {
      const feature = state.features.find((feature) => feature.slug === slug);
      if (!feature) {
        return false;
      }

      return feature.is_active;
    },
  },
  mutations: {
    addLocalFeature(state, payload) {
      state.features[payload.slug] = payload.is_active;
    },
    reset(state) {
      state.features = [];
    },
    resetFeature(state, slug) {
      state.features = state.features.filter(
        (feature) => feature.slug !== slug
      );
    },
  },
  actions: {
    async check({ state, commit, getters }, featureSlug) {
      if (getters.getFeature(featureSlug)) {
        return getters.getFeature(featureSlug).is_active;
      }

      const response = await checkIsActive(featureSlug);
      const isActive = response.is_active;

      state.features.push({
        slug: featureSlug,
        is_active: isActive,
      });

      console.log(featureSlug, isActive);

      return isActive;
    },
  },
};
